module.exports = __webpack_public_path__ + "static/myrkul-sigil-MTG_CLB-3ca744b312fa110e364d09f42e163f7c.png";